const defaultGetColor = (value) => {
  if (!value && value !== 0) {
    return 'empty';
  }
  if (value <= 30) {
    return 'error';
  } else if (value <= 70) {
    return 'warning';
  } else {
    return `success ${value === 100 ? 'full' : ''}`;
  }
};

const CircularProgress = ({ percentage, title, number, size = 'sm', getColor = defaultGetColor, hoverVariant = false, hasPercentageChar = false, isLoading = false, showNumber = true, style, className, percentageCharStyle, ...rest }) => {
  const radius = 16;
  const strokeWidth = 3.5;
  const circumference = 2 * Math.PI * radius;
  let strokeDashoffset = percentage !== undefined ? circumference - (percentage / 100) * circumference : circumference;
  strokeDashoffset = isNaN(strokeDashoffset) ? 0 : strokeDashoffset;

  const numberText = number || number === 0 ? number : percentage !== undefined ? Math.round(percentage) : '?';

  return (
    <div className={`comp-circular-progress size-${size} ${hoverVariant ? 'hover-variant' : ''} ${className}`} style={style} data-title={title || `${numberText}%`} {...rest}>
      <svg viewBox="0 0 36 36">
        <circle className="bg" cx="18" cy="18" r={radius} strokeWidth={strokeWidth} />
        <circle className={`progress ${getColor(percentage)}`} cx="18" cy="18" r={radius} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" />
      </svg>
      {!isLoading && showNumber && (
        <p className={`number-text ${getColor(percentage)}`}>
          {numberText}
          {hasPercentageChar && <span style={percentageCharStyle}>%</span>}
        </p>
      )}
    </div>
  );
};

export default CircularProgress;
